import i18next from 'i18next';
import React from 'react';

import { METRIC_TYPE } from '../../common/utils';
import PreviousCurrentCell from '../../common/PreviousCurrentCell';

export const channelColumns = (selectedMetric, isPercentage) => {
  if (!selectedMetric) {
    return [];
  }

  const isCurrency = selectedMetric.type === METRIC_TYPE.CURRENCY;
  const columns = [
    {
      field: 'storeName',
      headerName: i18next.t('GENERAL.STORE'),
      width: 200,
      sortable: true,
    },
    {
      field: 'total',
      headerName: selectedMetric.name,
      width: 180,
      sortable: true,
      sortComparator: (a, b) => a.current - b.current,
      renderCell: (params) => (
        <PreviousCurrentCell
          current={params.value?.current}
          isCurrency={isCurrency}
          previous={params.value?.previous}
        />
      ),
    },
    {
      field: 'eatin' + (isPercentage ? 'Percentage' : ''),
      headerName: i18next.t('ANALYSIS.PERFORMANCE.DINE_IN'),
      width: 180,
      sortable: true,
      sortComparator: (a, b) => a.current - b.current,
      renderCell: (params) => (
        <PreviousCurrentCell
          current={params.value?.current}
          isCurrency={!isPercentage && isCurrency}
          isPercentage={isPercentage}
          previous={params.value?.previous}
        />
      ),
    },
    {
      field: 'takeaway' + (isPercentage ? 'Percentage' : ''),
      headerName: i18next.t('ANALYSIS.PERFORMANCE.TAKEAWAY'),
      width: 180,
      sortable: true,
      sortComparator: (a, b) => a.current - b.current,
      renderCell: (params) => (
        <PreviousCurrentCell
          current={params.value?.current}
          isCurrency={!isPercentage && isCurrency}
          isPercentage={isPercentage}
          previous={params.value?.previous}
        />
      ),
    },
    {
      field: 'delivery' + (isPercentage ? 'Percentage' : ''),
      headerName: i18next.t('ANALYSIS.PERFORMANCE.DELIVERY'),
      width: 180,
      sortable: true,
      sortComparator: (a, b) => a.current - b.current,
      renderCell: (params) => (
        <PreviousCurrentCell
          current={params.value?.current}
          isCurrency={!isPercentage && isCurrency}
          isPercentage={isPercentage}
          previous={params.value?.previous}
        />
      ),
    },
  ];

  return columns;
};

export const deliveryColumns = (selectedMetric, isPercentage) => {
  if (!selectedMetric) {
    return [];
  }

  const isCurrency = selectedMetric.type === METRIC_TYPE.CURRENCY;
  const columns = [
    {
      field: 'storeName',
      headerName: i18next.t('GENERAL.STORE'),
      width: 200,
      sortable: true,
    },
    {
      field: 'delivery',
      headerName: i18next.t('ANALYSIS.PERFORMANCE.DELIVERY'),
      width: 180,
      sortable: true,
      sortComparator: (a, b) => a.current - b.current,
      renderCell: (params) => (
        <PreviousCurrentCell
          current={params.value?.current}
          isCurrency={isCurrency}
          previous={params.value?.previous}
        />
      ),
    },
    {
      field: 'ubereats' + (isPercentage ? 'Percentage' : ''),
      headerName: i18next.t('ANALYSIS.PERFORMANCE.UBEREATS'),
      width: 180,
      sortable: true,
      sortComparator: (a, b) => a.current - b.current,
      renderCell: (params) => (
        <PreviousCurrentCell
          current={params.value?.current}
          isCurrency={!isPercentage && isCurrency}
          isPercentage={isPercentage}
          previous={params.value?.previous}
        />
      ),
    },
    {
      field: 'deliveroo' + (isPercentage ? 'Percentage' : ''),
      headerName: i18next.t('ANALYSIS.PERFORMANCE.DELIVEROO'),
      width: 180,
      sortable: true,
      sortComparator: (a, b) => a.current - b.current,
      renderCell: (params) => (
        <PreviousCurrentCell
          current={params.value?.current}
          isCurrency={!isPercentage && isCurrency}
          isPercentage={isPercentage}
          previous={params.value?.previous}
        />
      ),
    },
    {
      field: 'other' + (isPercentage ? 'Percentage' : ''),
      headerName: i18next.t('ANALYSIS.PERFORMANCE.OTHER'),
      width: 180,
      sortable: true,
      sortComparator: (a, b) => a.current - b.current,
      renderCell: (params) => (
        <PreviousCurrentCell
          current={params.value?.current}
          isCurrency={!isPercentage && isCurrency}
          isPercentage={isPercentage}
          previous={params.value?.previous}
        />
      ),
    },
  ];

  return columns;
};
